<template>
  <transition name="incident-fade">
    <div v-if="visible" class="incident-modal-overlay" role="presentation">
      <div
        class="incident-modal-card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="incident-modal-title"
      >
        <div class="incident-header">
          <div class="incident-header-top">
            <div class="incident-brand">
              <div class="incident-brand-mark">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path
                    d="M12 9v4m0 4h.01M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z"
                    stroke="currentColor"
                    stroke-width="1.8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div class="incident-brand-copy" style="text-align: left;">
                <span class="incident-kicker">{{ $t('templateComps.channexIncident.kicker') }}</span>
                <span class="incident-brand-title">{{ $t('templateComps.channexIncident.brandTitle') }}</span>
              </div>
            </div>

            <button
              type="button"
              class="incident-close-btn"
              :aria-label="$t('templateComps.channexIncident.closeLabel')"
              @click="$emit('close')"
            >
              <i class="fal fa-times"></i>
            </button>
          </div>

          <div class="incident-header-meta">
            <div class="incident-subtitle">
              {{ $t('templateComps.channexIncident.subtitle') }}
            </div>
          </div>
        </div>

        <div class="incident-content">
          <h2 id="incident-modal-title" class="incident-title">
            {{ $t('templateComps.channexIncident.title') }}
          </h2>

          <p class="incident-lead">
            {{ $t('templateComps.channexIncident.lead') }}
          </p>

          <p class="incident-text">
            {{ $t('templateComps.channexIncident.text') }}
          </p>

          <div class="incident-note">
            <div class="incident-note__icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path
                  d="M12 8v5m0 4h.01M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div class="incident-note__body">
              {{ $t('templateComps.channexIncident.note') }}
            </div>
          </div>

          <p class="incident-text incident-text--last">
            {{ $t('templateComps.channexIncident.textLast') }}
          </p>
        </div>

        <div class="incident-actions">
          <button type="button" class="incident-primary-btn" @click="$emit('close')">
            {{ $t('templateComps.channexIncident.button') }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ChannexIncidentModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=DM+Sans:wght@500;600;700;800&family=Inter:wght@400;500;600;700;800&display=swap");

.incident-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 99998;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background:
    radial-gradient(circle at top, rgba(248, 113, 113, 0.18), transparent 38%),
    rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(8px);
}

.incident-modal-card {
  position: relative;
  width: min(720px, 100%);
  border-radius: 28px;
  overflow: hidden;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, rgba(248, 250, 252, 0.98) 100%);
  border: 1px solid rgba(226, 232, 240, 0.95);
  box-shadow: 0 28px 80px rgba(15, 23, 42, 0.28);
  font-family: "DM Sans", sans-serif;
}

.incident-close-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  min-width: 42px;
  height: 42px;
  border: none;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.92);
  color: #64748b;
  font-size: 1rem;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);
  cursor: pointer;
  transition: transform 0.18s ease, background 0.18s ease, color 0.18s ease;
}

.incident-close-btn:hover {
  transform: translateY(-1px);
  background: #f8fafc;
  color: #0f172a;
}

.incident-header {
  padding: 24px 28px 18px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  background:
    linear-gradient(135deg, rgba(255, 244, 229, 0.96) 0%, rgba(255, 250, 244, 0.92) 42%, rgba(255, 255, 255, 0.96) 100%);
  border-bottom: 1px solid rgba(241, 245, 249, 0.95);
}

.incident-header-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
}

.incident-brand {
  display: inline-flex;
  align-items: center;
  gap: 12px;
}

.incident-brand-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 14px;
  background: rgba(217, 119, 6, 0.12);
  color: #c2410c;
}

.incident-brand-copy {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.incident-kicker {
  color: #b45309;
  font-family: "DM Sans", sans-serif;
  font-size: 0.74rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.incident-brand-title {
  color: #0f172a;
  font-family: "DM Sans", sans-serif;
  font-size: 0.84rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.incident-header-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.incident-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 13px;
  border-radius: 999px;
  background: rgba(217, 119, 6, 0.12);
  color: #b45309;
  font-family: "DM Sans", sans-serif;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.01em;
}

.incident-subtitle {
  color: #7c8699;
  font-family: "DM Sans", sans-serif;
  font-size: 0.88rem;
  line-height: 1.45;
  font-weight: 500;
  text-align: right;
}

.incident-content {
  padding: 28px 32px 18px;
  color: #334155;
}

.incident-title {
  margin: 0 0 16px;
  color: #0f172a;
  font-family: "DM Sans", sans-serif;
  font-size: clamp(1.3rem, 1.9vw, 1.75rem);
  line-height: 1.22;
  font-weight: 800;
  max-width: 94%;
  text-align: left;
}

.incident-lead {
  margin: 0 0 10px;
  color: #0f172a;
  font-family: "DM Sans", sans-serif;
  font-size: 0.98rem;
  line-height: 1.62;
  font-weight: 600;
  text-align: left;
  max-width: 88%;
}

.incident-text {
  margin: 0 auto 14px;
  font-family: "DM Sans", sans-serif;
  font-size: 0.95rem;
  line-height: 1.68;
  color: #475569;
  text-align: center;
  max-width: 86%;
}

.incident-text--last {
  margin-bottom: 0;
}

.incident-note {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 14px;
  margin: 18px 0 18px;
  padding: 16px 18px;
  border-radius: 18px;
  background: linear-gradient(180deg, #fff7ed 0%, #fffbf5 100%);
  border: 1px solid rgba(251, 191, 36, 0.28);
}

.incident-note__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 12px;
  background: rgba(245, 158, 11, 0.14);
  color: #c2410c;
}

.incident-note__body {
  color: #9a3412;
  font-family: "DM Sans", sans-serif;
  font-size: 0.95rem;
  line-height: 1.65;
  font-weight: 600;
  text-align: left;
}

.incident-actions {
  display: flex;
  justify-content: flex-end;
  padding: 0 32px 28px;
}

.incident-primary-btn {
  border: none;
  border-radius: 16px;
  padding: 13px 22px;
  min-width: 150px;
  background: linear-gradient(135deg, #f97316 0%, #ea580c 100%);
  color: #fff;
  font-family: "DM Sans", sans-serif;
  font-size: 0.95rem;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 14px 28px rgba(234, 88, 12, 0.22);
  transition: transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease;
}

.incident-primary-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 18px 32px rgba(234, 88, 12, 0.26);
  filter: saturate(1.04);
}

.incident-fade-enter-active,
.incident-fade-leave-active {
  transition: opacity 0.2s ease;
}

.incident-fade-enter,
.incident-fade-leave-to {
  opacity: 0;
}

@media (max-width: 768px) {
  .incident-modal-overlay {
    padding: 14px;
    align-items: flex-end;
  }

  .incident-modal-card {
    border-radius: 24px 24px 18px 18px;
  }

  .incident-header,
  .incident-content,
  .incident-actions {
    padding-left: 20px;
    padding-right: 20px;
  }

  .incident-header {
    padding-top: 24px;
  }

  .incident-header-top,
  .incident-header-meta {
    flex-direction: column;
    align-items: flex-start;
  }

  .incident-subtitle {
    text-align: left;
  }

  .incident-title,
  .incident-lead,
  .incident-text {
    max-width: 100%;
  }

  .incident-actions {
    padding-bottom: 22px;
  }

  .incident-primary-btn {
    width: 100%;
  }
}
</style>
